import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function Home() {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-gray-100 mb-4">Welcome to TeamTactics</h1>
          <p className="text-xl text-gray-600 dark:text-gray-400 mb-8">Get started by managing your players</p>
          <Link
            to="/players"
            className="inline-block bg-primary-600 dark:bg-primary-500 text-white px-6 py-3 rounded-md hover:bg-primary-700 dark:hover:bg-primary-600 transition-colors"
          >
            Go to Players
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-primary-50 to-white dark:from-gray-900 dark:to-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center">
          <h1 className="text-5xl font-bold text-gray-900 dark:text-gray-100 mb-4">TeamTactics</h1>
          <p className="text-xl text-gray-600 dark:text-gray-400 mb-8">
            Fair, balanced teams for small-sided football games
          </p>

          <div className="space-x-4">
            <Link
              to="/login"
              className="inline-block bg-primary-600 dark:bg-primary-500 text-white px-6 py-3 rounded-md hover:bg-primary-700 dark:hover:bg-primary-600 transition-colors"
            >
              Sign In
            </Link>
            <Link
              to="/register"
              className="inline-block bg-white dark:bg-gray-800 text-primary-600 dark:text-primary-400 border border-primary-600 dark:border-primary-500 px-6 py-3 rounded-md hover:bg-primary-50 dark:hover:bg-primary-900/20 transition-colors"
            >
              Sign Up
            </Link>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm">
            <div className="text-4xl mb-4">🎯</div>
            <h3 className="text-xl font-semibold mb-2 dark:text-gray-100">Comprehensive Rating System</h3>
            <p className="text-gray-600 dark:text-gray-400">
              21 attributes across Technical, Physical, and Mental categories
            </p>
          </div>

          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm">
            <div className="text-4xl mb-4">⚖️</div>
            <h3 className="text-xl font-semibold mb-2 dark:text-gray-100">AI-Powered Balancing</h3>
            <p className="text-gray-600 dark:text-gray-400">
              5000 iterations to find the most balanced team combination
            </p>
          </div>

          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm">
            <div className="text-4xl mb-4">📊</div>
            <h3 className="text-xl font-semibold mb-2 dark:text-gray-100">Match History</h3>
            <p className="text-gray-600 dark:text-gray-400">
              Track scores and maintain historical records of all your games
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
